import axios from 'axios';
// const API_URL = process.env.URL_API;
const Api = axios.create({baseURL: 'https://api.usedng.com.br:3003', headers: {'x-access-token': localStorage.getItem('token')}});
export default Api;